<template>
  <div v-loading="loading" class="content">
    <div>
      <div v-if="dataList && dataList.length>0" class="news">
        <div class="headerTitle">
          <div class="title">
            标题
          </div><div class="time">
            发布日期
          </div>
        </div>
        <div v-for="item in dataList" :key="item.id" class="news-item">
          <router-link
            :to="{ name: 'Detail', params: { id: item.id},query:{
              source:propsData.source
            }}"
            :title="item.title"
          >
            {{ item.title }}
            <span v-show="item.recommendStatus"><img :src="require('@/assets/img/hot.png')" alt=""></span>
          </router-link>
          <span class="right">{{ item.createDate }}</span>
        </div>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
      <global-empty
        v-else
        :label="`暂无数据~`"
        link-it="3"
        height="240"
      />
    </div>
  </div>
</template>
<script>

// 获取API
import getContent from '@/api/content';
export default {
  name: 'NewsTabList',
  props: {
    propsData: {
      type: Object,
      default: Object
    }
  },
  data: () => {
    return {
      loading: true,
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      dataList: [],
      classifyId: ''
    };
  },
  mounted() {
    this.classifyId = this.propsData.classifyId;
    this.getInfo();
  },
  methods: {
    // 获取列表
    getInfo() {
      this.loading = true;
      var option = {
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize,
        classifyId: this.classifyId
      };
      getContent[this.propsData.interface.list](option)
        .then(res => {
          if (res.data === null || res.data === '' || res.data === 'undefind') {
            this.dataList = [];
            this.searchForm.total = 0;
          } else {
            this.dataList = res.data.list;
            this.searchForm.total = res.data.total;
          }
          this.loading = false;
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '暂无数据'
          });
          this.loading = false;
        });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.getInfo();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.getInfo();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.content{
  padding:  0 40px;
}
.headerTitle{
  display: flex;
    background: #f4f4f4;
    height: 54px;
    line-height: 54px;
    font-size: 16px;
    padding: 0 40px;
    margin-bottom: 20px;
    margin-top: 10px;
  .title{
    flex: 1;
  }
  .time{
   width: 200px;
   text-align: right;
  }
}
  // .news{
  //   padding: 0 40px;
  // }
 .news-item{
    border-bottom: 1px solid transparent;
    background: linear-gradient(white,white) padding-box,
    repeating-linear-gradient(-45deg,#ECECEC 0, #ECECEC 0.30em,white 0,white 0.55em);
    padding: 14px 30px;
    a{
      max-width: 880px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
      display: inline-block;
      -webkit-line-clamp: 1;
    }
     &:hover a,&:hover .right{
      color: #007AFC;
      // text-decoration: underline;
    }
  }
   .search-result{
    display: flex;
    justify-content: space-between;
    padding: 10px 0 0 0;
    margin: 0 16px 0 20px;
    font-weight: bold;
    font-size: 18px;
    .result-title{
    font-weight: bold !important;
    font-size: 18px !important;
  }
  span{
    color: #0082F1;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
}
</style>
